module.exports = __webpack_public_path__ + "img/9788976966360.8e7498fa.jpg";